import { FC, useState } from "react";
import WidgetCard from "../Cards/WidgetCard";
import { Box, Grid, makeStyles, TextField, Typography } from "@material-ui/core";
import { ThemeComponent } from "../Types";

type WidgetGalleryPropType = {
  themeComponentList: ThemeComponent[];
  handleSelectedComponentChange: any;
  selectedComponent: null | string;
};

const useStyles = makeStyles(() => ({
  componentCard: {
    marginRight: '4px',
    overflow: 'hidden'
  },
  containerFlex: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    height: '92%', // ✅ instead of 90vh
    minHeight: 0,    // ✅ allow shrinking inside flex parent
  },
  headerSection: {
    flexShrink: 0,
  },
  scrollAreaFlex: {
    flex: 1,
    minHeight: 0,  // ✅ Required for scrollable flex children
    overflow: 'auto',  // ✅ Enable scroll always (not just on hover)
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    }
  }
}));

const WidgetGallery: FC<WidgetGalleryPropType> = ({ themeComponentList, handleSelectedComponentChange, selectedComponent }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const classes = useStyles();

  const filteredComponents = themeComponentList.filter((component) =>
    component.ComponentLabel?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box className={classes.containerFlex}>
      <Box className={classes.headerSection}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search widgets..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: '1rem' }}
        />
      </Box>

      <Box className={classes.scrollAreaFlex}>
        <Grid>
          {filteredComponents.map((component, idx) => (
            <Grid key={idx} className={classes.componentCard}>
              <WidgetCard componentDetails={component} handleSelectedComponentChange={handleSelectedComponentChange} selectedComponent={selectedComponent} />
            </Grid>
          ))}
        </Grid>
        {filteredComponents.length === 0 && (
          <Typography variant="body2" color="textSecondary">
            No widgets found.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default WidgetGallery;